const GetMetadataKeys = `
  query Query($count: Int, $cursor: String, $filterConfig: MetadataKeyFilterConfigInput) {
    metadataKeys(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`

module.exports = {
  GetMetadataKeys,
}
